import React, { Component } from 'react';
import {
  Button,
  Modal,
  Table,
  Row,
  Col,
  Icon,
  Form,
  Input,
  Select
} from 'antd';
import axios from 'axios';
import Moment from 'react-moment';
import { debounce } from "lodash";
import { Constant } from "../../../config";
import '../PriceManagement.css';

const sortBySelection = [
  { name: "Default", value : "id" },
  { name: "Price", value: "price" },
  { name: "Create Time", value: "created_date" }
]

class CostCompare extends Component {

  state = {
    data: [],
    pagination: {},
    loading: true,
    regionCode: ''
  };

  columns = [
    {
      title: 'Vendor',
      dataIndex: 'vendor',
      key: 'vendor',
      render: (text, record) => {
        return <span style={record.is_main_gateway ? {fontWeight: 'bold'} : null}>{record.gateway_name}</span>
      },
      align: 'center',
    },
    {
      title: 'Cost Price',
      dataIndex: 'cost_price',
      key: 'cost_price',
      render: (text, record) => {
        return <span style={record.is_main_gateway ? {color: '#1890ff'} : null}>{Number.parseFloat(record.price).toFixed(4)}</span>
      },
      align: 'center',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        return record.is_main_gateway ? <span style={{color: '#1890ff'}}>Main Gateway</span> : <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>Nomal Gateway</span>
      },
      align: 'center',
    },
    {
      title: 'Last Update',
      dataIndex: 'updated_date',
      key: 'updated_date',
      render: (text, record) => {
        if (record.last_change_logs.created_date === 0) return '-'
        return <div><div>{record.last_change_logs.event === 'update' ? 'Edit Price' : ''}</div><div><Moment unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">{record.last_change_logs.created_date}</Moment></div></div>
      },
      align: 'center',
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return <div className="text-link" style={{color: 'inherit'}} onClick={() => this.props.viewVendor(record.gateway_id)}>View Vendor</div>
      },
      align: 'center',
    },
  ];

  componentWillMount() {
    const { regionCode } = this.props
    this.setState({
      regionCode
    })
  }

  async componentDidMount() {
    await this._fetchCostCompareList()
  }

  _fetchCostCompareList = async (page = 1, limit = 10, filter = {order_by: 'id', order: 'asc', search: ''}) => {
    const url = `${Constant.COST_COMPARE_API.replace("[id]", this.state.regionCode)}`;
    for (const key in filter) {
      if (!filter[key]) {
        delete filter[key];
      }
    }
    const options = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
      params: {
        page,
        limit,
        ...filter,
      },
    };
    let resp;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    let pagination = { ...this.state.pagination };
    pagination.size = 'small';
    let d = [];

    let data = resp.data.data
    if (data) {
      d = data;
      pagination.total = resp.data.total_rows;
    }
    this.setState({
      loading: false,
      data: d,
      pagination
    });
  };

  _handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this._fetchCostCompareList(pager.current, pagination.pageSize);
  };

  _handleSearchChange = (values) => {
    const pagination = this.state.pagination;
    pagination.current = 1;
    this.setState({ 
      pagination,
      filter: values
    });
    this._fetchCostCompareList(1, 10, values);
  };

	render() {
    const { onCancel, visible, countryName } = this.props;
    let propsTable = {
      columns: this.columns,
      dataSource: this.state.data,
      rowKey: (record) => record.id,
      pagination: this.state.pagination,
      loading: this.state.loading,
      onChange: this._handleTableChange
    };

		return (
			<Modal
        className="my-layout"
        footer={
          <div style={{textAlign: 'center'}}>
            <Button key="cancel" onClick={onCancel}>
              Close
            </Button>
          </div>
        }
        onCancel={onCancel}
        closable={false}
        title={<div>Cost Comparison: <span style={{fontWeight: 'bold'}}>{countryName}</span></div>}
        visible={visible}
        width={1000}
      >
        <VendorSearchForm onSearch={this._handleSearchChange}/>
        <Table {...propsTable} />
      </Modal>
		)
	}
}

const VendorSearchForm = Form.create({name: "cost_compare_search_form"})(
	class extends Component {

    async componentDidMount() {
      await this.setFieldsValue();
    }
    
    setFieldsValue = () => {
      this.props.form.setFieldsValue({
        search: '',
        order_by: 'id'
      });
    }

    handleChangeSearch = (event) => {
      event.persist();
      if (!this.debouncedFn) {
        this.debouncedFn = debounce(() => {
          this.props.form.setFieldsValue({
            search: event.target.value
          });
          this.handleOnSearch()
        }, 600);
      }
  
      this.debouncedFn();
    }

    handleChangeSort = (event) => {
      this.props.form.setFieldsValue({
        order_by: event
      });
      this.handleOnSearch()
    }

    handleOnSearch = () => {
      this.props.form.validateFields((err, values) => {
        this.props.onSearch(values);
      });
    };

    render() {
      const { getFieldDecorator } = this.props.form;

      return (
        <Form layout="inline">
          <Row gutter={24}>
            <Col xs={{span: 24}} md={{span: 12}}>
              <Form.Item>
                {getFieldDecorator('search')(
                  <Input
                    type='text'
                    onChange={this.handleChangeSearch}
                    prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }}/>}
                    placeholder="Search Vendor"
                  />,
                )}
              </Form.Item>
            </Col>
            <Col xs={{span: 24}} md={{span: 12}}>
              <Row gutter={24} type='flex' justify="end">
                <Col>
                  <Form.Item label="Sort By">
                    {getFieldDecorator('order_by')(
                      <Select
                      placeholder="Sort By"
                      onChange={this.handleChangeSort}
                      style={{ width: '130px' }}
                    >
                      {sortBySelection.map((sort, idx) => {
                        return (
                          <Select.Option key={idx} value={sort.value}>
                            {sort.name}
                          </Select.Option>
                        )
                      })}
                    </Select>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      )
    }
	}
);

export default CostCompare


// WEBPACK FOOTER //
// ./src/containers/PriceManagement/Modals/CostCompare.js